frontApp.b_popup = {
  name: 'b_popup',
  description: 'Custom popup for "buy one click"',
  init() {
    const self = this;
    $('body')
      .on('click', '.b_modal_close', () => {
        $('#register_overlay').remove();
        $('#login_overlay').remove();
        $('#phone_login_overlay').remove();

        self.unlockScroll();

        return false;
      })
      .on('click', '#login_overlay, #register_overlay, #phone_login_overlay', (e) => {
        const $loginOverlay = $('#login_overlay');
        const $phoneLoginOverlay = $('#phone_login_overlay');
        const $registerOverlay = $('#register_overlay');
        const { target } = e;
        if ($loginOverlay.is(target)) {
          $loginOverlay.remove();
          self.unlockScroll();
        }
        if ($phoneLoginOverlay.is(target)) {
          $phoneLoginOverlay.remove();
          self.unlockScroll();
        }
        if ($registerOverlay.is(target)) {
          $registerOverlay.remove();
          self.unlockScroll();
        }
      });
  },
  unlockScroll() {
    document.body.style.marginRight = '';
    bodyScrollLock.clearAllBodyScrollLocks();
  },
};
